import React from 'react';
import Select from '@material-ui/core/Select';
import {cl,globs} from '../../components/utils/utils';

class C18MuiSelect extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
    }
  }
  
  render(){
//     cl(this.props.value)
//     cl(this.props.children)
    let pr=this.props
    let val=pr.value
    if(val!=null && typeof val==="object" && !Array.isArray(val)){val=val.val}
    if((typeof val)=="string"){
      // channel type and other string-valued selects
    }else if(val?.length){
      val=val[0]
    }else{
      val=(val==null || val==="")?0:+val
      if(isNaN(val)){val=0}
    }
//     cl(typeof pr.value)
//     cl(pr.value)
//           value={}
    if(globs.noMui){
      return(
        <div style={{marginBottom: pr.break==="none" ? 0 : 16}}>
          <div  className="custom-select float-left-box"
            style={{marginBottom:0}}>
          <select
            id={pr.id}
            title={pr.title}
            value={val /*pr.value||0*/}
            onChange={pr.onChange}
            disabled={!pr.saveOK}
            style={{backgroundColor:pr.bgColor}}
          >
            {pr.children}
          </select>
          <span className="material-icons down-arrow" style={{pointerEvents:"none", zIndex: 2}} translate="no">
            keyboard_arrow_down
          </span>
          </div>
          {pr.unit &&
            <span className="units">{pr.unit}</span>
          }
          {(pr.break!="none")&&
            <div className="clearfloat"></div>
          }
        </div>
      )
      return null
    }else{
      return React.createElement(Select, {...pr, value: val})
    }
  }
}
      
export default C18MuiSelect;
 
